
import Vue from "vue";

export default abstract class BasePortfolioStep extends Vue {
  protected completeStep(emittedData: any) {
    this.$emit("complete", emittedData);
  }

  protected goToPreviousStep() {
    this.$emit("previous-step");
  }
}
